import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toastConfig } from "config"
import { useContext } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { app } from "router/routes"
import { updateTicketFetch } from "store/middlewares/tickets.crud"
import { TicketContext } from "../TicketContext"
import { queryClient as qc, ticketStatuses } from "keys"

const useCloseTicket = () => {
    const params = useParams()
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    const { ticket } = useContext(TicketContext)
    const isCloseTicket = ticket.data?.status == ticketStatuses.CLOSE

    const { mutateAsync: closeTicket } = useMutation({
        mutationFn: () => updateTicketFetch({ id: params.ticketID, status: "CLOSE" }),
        onSuccess: () => {
            queryClient.refetchQueries([qc.tickets])
            navigate(app.tickets)
            toast.dismiss()
            toast("הפניה נסגרה", toastConfig)
        }
    })
    const { mutateAsync: openTicket } = useMutation({
        mutationFn: () => updateTicketFetch({ id: params.ticketID, status: "OPEN" }),
        onSuccess: () => {
            toast.dismiss()
            toast("הפניה נפתחה", toastConfig)
            queryClient.invalidateQueries([qc.ticket])
        }
    })

    const closeTicketBtn = {
        systemUI: false,
        fullWidth: true,
        color: "thirdly",
        label: !isCloseTicket ? "סגור פנייה" : "פתח פניה מחדש",
        action: !isCloseTicket ? closeTicket : openTicket
    }

    return closeTicketBtn
}

export default useCloseTicket